import type { FC, ReactNode } from "react";
import * as s from "./CategoryUsp.module.scss";

type Props = { background?: string; children: ReactNode };

const CategoryUsp: FC<Props> = ({ background, children }) => {
	return (
		<div className={s.container} style={{ backgroundColor: background }}>
			{children}
		</div>
	);
};

export default CategoryUsp;
